import { render, staticRenderFns } from "./city-town-select.vue?vue&type=template&id=813d214e"
import script from "./city-town-select.vue?vue&type=script&lang=js"
export * from "./city-town-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports